import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { SsrHelperService } from './ssr-helper.service';

@Injectable()
export class AudioPlayerService {
  public audio: HTMLAudioElement;

  private audioInterval = null;
  private audioPausedEvt = new BehaviorSubject<string>('');
  public readonly audioPausedEvt$ = this.audioPausedEvt.asObservable();

  constructor(private readonly ssrHelperService: SsrHelperService) {
    if (this.ssrHelperService.userAgent) {
      this.audio = new Audio();
    }
  }

  public async play(src: string): Promise<void> {
    if (!this.audio.paused) {
      this.audio.pause();

      if (this.audioInterval) {
        clearInterval(this.audioInterval);
      }
    }

    if (this.audio.src !== src) {
      this.audio.src = src;
      this.audio.load();
      this.audioPausedEvt.next(src);

      this.audioInterval = setInterval(() => {
        if (this.audio.currentTime >= 55 || this.audio.ended) {
          clearInterval(this.audioInterval);
          this.pause(true);
          this.audioPausedEvt.next(src);
        }
      }, 5000);
    }

    await this.audio.play();
  }

  public pause(reset = false) {
    this.audio.pause();
    if (reset) {
      this.audio.currentTime = 0;
    }
  }
}
